import {
  Promise
} from 'es6-promise-polyfill'

import {
  WZ,
  XUtils,
  WZUtils
} from './globals'
import {
  HOST_WEB
} from '../store/const';

function formatUserInfo(UserInfo) {
  const logo = UserInfo.logo || {}
  UserInfo.logoSrc = logo.thumb120 || logo.thumb50 || logo.thumb || logo.src || ''
  return UserInfo
}

// 加载用户信息
WZ.apiRegister('my-user-info', {
  protoId: 25,
  path: '/user/myinfo/',
  checkResult(R) {
    if (!XUtils.isPlain(R.uinfo)) {
      return 1001 // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    return formatUserInfo(R.uinfo)
  }
})

// 格式化商品名
function formatName(name) {
  name = name.replace(/(one)(year)/g, '$1-$2')
  name = name.replace(/([A-Z])/g, '-$1').toLowerCase()
  return name
}

function formatSubType(name) {
  const SubType = {
    oneyearPre: '11',
    oneyearLessonPre: '12',
    giftOnePre: '21',
    giftTwoPre: '22',
    giftThreePre: '23',
    oneyear: '11',
    oneyearLesson: '12',
    giftOne: '21',
    giftTwo: '22',
    giftThree: '23'
  }
  return SubType[name] ? SubType[name] : name
}

// 加载售卖信息
WZ.apiRegister('my-sale-info', {
  protoId: 857,
  path: '/award/klinev1/sale20181111/',
  checkResult(R) {
    if (!XUtils.isNumber(R.saleType) || !XUtils.isPlain(R.data)) {
      return 1001 // 数据格式非法
    }
    var data = R.data
    if (!XUtils.isPlain(data.pre) || !XUtils.isPlain(data.last)) {
      return 1002 // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    R = R || {}
    const {
      data,
      saleType,
      buyInfos,
      sale20181111Begin,
      sale20181111PreEnd,
      subId
    } = R
    let {
      canGoodsIds,
      physicalGoods
    } = R
    const goodsMap = {}
    canGoodsIds = canGoodsIds || []
    physicalGoods = physicalGoods || []

    const typedMap = {}

    function addGoods(map, type) {
      XUtils.forIn(map, (goods, name) => {
        const goodsId = goods.goodsId;
        const subType = formatSubType(name)
        goods.type = type
        goods.name = formatName(name)
        goods.subType = subType
        goods.isPhysical = physicalGoods.indexOf(goodsId) > -1 // 是否为实物
        goodsMap[goods.goodsId] = goods

        const typedGoods = typedMap[subType] || {}
        typedGoods[type] = goods
        typedMap[subType] = typedGoods
      })
    }
    addGoods(data.pre, 'pre')
    addGoods(data.last, 'last')
    const preMap = data.pre || {}
    const lastMap = data.last || {}
    // console.log(TypedGoods);

    XUtils.forIn(typedMap, function(O) {
      const {pre, last} = O
      if(pre && last) {
        pre.lastId = last.goodsId;
        pre.preId = pre.goodsId;

        last.preId = pre.goodsId;
        last.lastId = last.goodsId;
      }
    })
    // console.log(lastMap);

    // R = {
    //   ...R,
    //   GoodsMap
    // }
    return {
      subId,
      saleType,
      goodsMap,
      preMap,
      lastMap,
      canGoodsIds,
      buyInfos,
      sale20181111Begin,
      sale20181111PreEnd,
      typedMap
    }
  }
})

// 下单
WZ.apiRegister('sale-20181111-order', {
  protoId: 384,
  path: '/award/klinev1/order/',
  formatQuery(query) {
    return XUtils.assign({
      area: 'sale20181111'
    }, query)
  }
})


export async function loadApi(name, query) {
  return new Promise((success, fail) => {
    WZ.apiSend({
      name,
      query,
      onsuccess(r) {
        success(r)
      },
      onfail(e) {
        fail(e)
      }
    })
  })
}

export function loadUserInfo(query) {
  const userInfo = WZUtils.getUserInfo()
  if (userInfo && userInfo.uid > 0) {
    return new Promise((success) => {
      // console.log(userInfo);
      success(formatUserInfo(userInfo))
    })
  } else {
    return loadApi('my-user-info', query || {})
  }
}

export async function loadSaleInfo(query) {
  return loadApi('my-sale-info', query || {})
}

export async function loadOrder(query, returnUrl) {
  return loadApi('sale-20181111-order', query || {}).then(res => {
    returnUrl = returnUrl || `https://${HOST_WEB}/award/klinev2/sale/?#/buy/${query.goodsId}`
    const url = `https://${HOST_WEB}/award/klinev2/buy-result/?` + XUtils.o2q({
      orderId: res.orderId,
      returnUrl: returnUrl
    })
    // 跳转至收银台
    WZ.go("cash", {
      orderSn: res.orderSn,
      orderId: res.orderId,
      orderScene: res.orderScene,
      redirectUrl: url
    });
    return res
  })
}

// export async function goCost(data) {
//   WZ.go("cash", {
//     orderSn: data.orderSn,
//     orderId: data.orderId,
//     orderScene: data.orderScene,
//     redirectUrl: location.href
//   });
// }


// 获取我的二维码接口
WZ.apiRegister('my-qr-code', {
  protoId: 858,
  path: '/award/subscribe/getmyqrcode/',
  checkResult(R) {
    if (!R.url || !/https?:\/\//.test(R.url)) {
      return 501
    }
    return 0
  }
})

export async function loadQrCode(subId) {
  return loadApi('my-qr-code', {
    sId: subId
  })
}


// 斗K购买信息
WZ.apiRegister('kline-buy-info', {
  protoId: 858,
  path: '//award/klinev1/buyinfo/',
  checkResult(R) {
    if (!R.buyInfo) {
      return 501
    }
    return 0
  }
})
export async function loadDkBuyInfo(orderId) {
  return loadApi('kline-buy-info', {
    orderId
  })
}
